export default __webpack_public_path__ + "static/media/android-1.c3955b99.jpeg";